import { actionCreators } from './ReferenceWeightsState';
import {
  ReferenceWeightsImportRecords,
  UpdateWeightRefInfo,
} from '../../Interfaces/ReferenceWeightsImport';
import { Dispatch } from 'redux';

export const saveWeightRefImportInfo = async (
  dispatch: any,
  value: ReferenceWeightsImportRecords
) => {
  return dispatch(actionCreators.saveWeightRefImportInfo(value));
};

export const uploadRefWeightsFile = async (
  dispatch: any,
  filePath: string,
  data: UpdateWeightRefInfo[]
) => {
  return dispatch(actionCreators.uploadRefWeightsFile(filePath, data));
};

export const fetchReferenceWeightsFolderPath = async (dispatch: any) => {
  return dispatch(actionCreators.fetchReferenceWeightsFolderPath());
};

export const processCSVImport = async (dispatch: any, serverPath: string) => {
  return dispatch(actionCreators.processCSVImport(serverPath));
};
export const fetchReferenceWeightsFilePath = async (
  dispatch: Dispatch<any>
) => {
  return dispatch(actionCreators.fetchReferenceWeightsFilePath());
};
